$(document).ready(() => {
  let placeInLine = null;
  let waitingQueue = document.getElementById("waiting_queue");
  let publicId = new URLSearchParams(window.location.search).get("id");

  if (waitingQueue) {
    App.user_membership = App.cable.subscriptions.create(
      { channel: "UserMembershipChannel", waiting_id: waitingQueue.dataset["waitingId"] },
      {
        received(data) {
          if (data.status == "success") {
            App.waiting_list.unsubscribe();

            if (data.redirect_url) {
              window.location.href = data.redirect_url;
            };
          } else {
            toastr.error(data.message);

            let buyButton = document.querySelector(".js-buy-button");
            buyButton.innerHTML = buyButton.dataset["label"];
            Rails.enableElement(buyButton);
            buyButton.removeAttribute("disabled");
            buyButton.classList.remove("disabled");
          }
        }
      }
    );
  }
});
